import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  getLoginMessage,
  loginPage,
  getNothingToBookMessage,
  getTimeSlotIsFullMessage,
  getOnlyAllowStatusMessage,
  removeCookies,
  getNotAllowedForSunBookersMessage,
  getNotFullyPaidMessage,
} from '../../utils';
import './Alert.scss';

const getMessage = message => (message.includes('\n')
  ? message.split('\n').map((chunk, index) => (<div key={index}>{chunk}</div>))
  : (<div>{message}</div>));

const Alert = ({ message, clearErrorMessage, notFound = false }) => {
  const [show, setShow] = useState(true);
  if (!show) return null;
  const showLoginButton = getLoginMessage() === message || notFound;
  const isNothingToBook = getNothingToBookMessage() === message;
  const isTimeSlotFull = getTimeSlotIsFullMessage() === message;
  const isLoginDenied = getOnlyAllowStatusMessage('CX') === message || getOnlyAllowStatusMessage() === message;
  const isSunBookersLoginDenied = getNotAllowedForSunBookersMessage() === message;
  const isNotFullyPaid = getNotFullyPaidMessage() === message;
  return (
    <div className="alert overlay">
      <div className="error">
        {getMessage(message)}
        {isSunBookersLoginDenied && (
          <a href="mailto:sunenquiries@butlins.com">sunenquiries@butlins.com</a>
        )}
      </div>
      {
        showLoginButton && (
          <Link
            className="alert-btn"
            to={loginPage}
            onClick={() => {
              removeCookies();
              window.location.reload();
            }}
          >
            Login
          </Link>
        )
      }
      {
        (isNothingToBook || isLoginDenied) && (
          <Link
            className="alert-btn"
            to="/"
            onClick={() => {
              if (clearErrorMessage) clearErrorMessage();
              setShow(false);
              window.location.href = window.location.origin;
            }}
          >
            Go back to Butlins
          </Link>
        )
      }
      {
        isTimeSlotFull && (
          <div
            className="alert-btn"
            onClick={() => {
              window.location.reload();
            }}
          >
            OK
          </div>
        )
      }
      {
        !showLoginButton && !isNothingToBook && !isTimeSlotFull && !isLoginDenied && (
          <div
            className="alert-btn"
            onClick={() => {
              if (clearErrorMessage) clearErrorMessage();
              setShow(false);
            }}
          >
            Ok
          </div>
        )
      }
      {
        isNotFullyPaid && (
          <div
            className="alert-btn"
            onClick={() => {
              window.location.href = 'https://holidays.butlins.com/sw/MRetrieveBooking.do';
            }}
          >
            Make payment
          </div>
        )
      }
    </div>
  );
};

Alert.propTypes = {
  message: PropTypes.string.isRequired,
  notFound: PropTypes.bool,
  clearErrorMessage: PropTypes.func,
};

export default Alert;
